/**
 * @file store.workers.copyFields.js
 * @description copies fields from source to target.
 *              used to update a client-side object with
 *              fields from the server.
 * 
 *              fields must exist in the target to get copied.
 *
 *              notes: updates targetObj in-place
 * 
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 07, 2025 12:19
 */
import { objectExists } from 'src/@common/utilities';

function copyFields(sourceObj, targetObj) {

    if (objectExists(sourceObj) &&
        objectExists(targetObj)) {

        for (const key in sourceObj) {
            if (Object.hasOwn(targetObj, key)) {
                targetObj[key] = sourceObj[key];
            }
        }
    }
}

export default copyFields;